import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    open: false,
    org: {},
    chatSettingsData: {},
    isLoading: true,
    shopId: null,
    shopHas360: null,
    width: 0,
    height: 0,
    appUrl: "",
    preview: false,
    pageContext: null,
    // The brand owner's own sign-in sentence, read with the settings on load.
    // Empty until it answers, and empty for a brand that wrote none, which
    // means the panel says its built-in wording - see signInInvitation.
    guestSignInLine: "",
    pendingMessage: null,
    // Voice asked for from the product card: the conversation opens listening.
    pendingVoice: false,
    // Set (to a fresh number) when the card's voice starts: the panel's stops.
    voiceStopRequest: 0,
};

const ChatServicesSlice = createSlice({
    name: "chatServicesData",
    initialState,
    reducers: {
        setChatServicesData: (state, { payload }) => {
            return { ...state, ...payload };
        },
    },
});

export const { setChatServicesData } = ChatServicesSlice.actions;

export default ChatServicesSlice;
